
    
    
    <div class="row  mb-2">
        <div class="col pl-3">
            <h4 class="mb-0 font-header-1 mb-2" style="font-weight: 700;">Timesheet</h4>
        </div>
    </div>
    <div
        *ngIf="global.globalAgencyId!=null && global.globalAgencyId!=undefined && global.globalAgencyId!=0 && global.globalAgencyId != '' && global.globalAgencyId != '00000000-0000-0000-0000-000000000000'; else elsecondition">
        <div class="row mt-4" *ngIf="!manualEntry">
            <div class="col-12 mt-3 p-0">
                <div widget class="card border-0 box-shadow">
                    <div class="card-body transparent">
                    <div>
                        <div class="row mt-2">
                            <!-- From Date -->
                            <div class="col-lg-3">
                                <div class="col-lg-12">
                                    <label style="font-weight:bold">From <sup class="super-script">*</sup></label>
                                </div>
                                <div class="col-lg-12">
                                    <my-date-picker [options]="myDatePickerOptions" id="TVFromDate"
                                        [selDate]="filters.filterStartDate" placeholder="mm/dd/yyyy"
                                        (inputFieldChanged)="TimesheetViewDatePickers($event,'inputchanged','filterstart')"
                                        (dateChanged)="TimesheetViewDatePickers($event,'datachanged','filterstart')">
                                    </my-date-picker>
                                </div>
                            </div>
                            <!-- To Date -->
                            <div class="col-lg-3">
                                <div class="col-lg-12">
                                    <label style="font-weight:bold">To<sup class="super-script">*</sup> </label>
                                </div>
                                <div class="col-lg-12">
                                    <my-date-picker id="TVEndDate" [options]="myDatePickerOptions"
                                        [selDate]="filters.filterEndDate" placeholder="mm/dd/yyyy"
                                        (inputFieldChanged)="TimesheetViewDatePickers($event,'inputchanged','filterend')"
                                        (dateChanged)="TimesheetViewDatePickers($event,'datachanged','filterend')">
                                    </my-date-picker>
                                </div>
                            </div>
                            <!-- Payor -->
                            <div class="col-lg-3">
                                <div class="col-lg-12">
                                    <label style="font-weight:bold">Payor </label>
                                </div>
                                <div class="col-lg-12 d-flex">
                                    <ng-select class="w-100" id="TVPayor" [(ngModel)]="filters.filterPayor"
                                        [searchable]="true" [clearable]="true" [items]="ViewInputProperty.PayorDropDown"
                                        bindLabel="Value" bindValue="Key">
                                    </ng-select>
                                    <app-dropdown (EmitRefreshClick)="refreshtoPayorDropdownValues()"></app-dropdown>
                                </div>
                            </div>
                            <!-- Timesheet_isLinked Status -->
                            <div class="col-lg-3">
                                <div class="col-lg-12">
                                    <label style="font-weight:bold">Auth Timesheet Status </label>
                                </div>
                                <div class="col-lg-12 d-flex">
                                    <ng-select class="w-100"  [(ngModel)]="filters.filterIsTImesheetLinked"
                                        [searchable]="true" [clearable]="true" [items]="timesheetIsLinkedList"
                                        bindLabel="Value" bindValue="Key">
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <!-- Employee -->
                            <div class="col-lg-6">
                                <div class="col-lg-12">
                                    <label style="font-weight:bold">Employee </label>
                                </div>
                                <div class="col-lg-12 d-flex">
                                    <ng-select [(ngModel)]="filters.filterEmployee" id="TVEmployee" [searchable]="true"
                                        class="w-100" [clearable]="true" [items]="AllEmployeeDropDownListwithStatus"
                                        bindLabel="names" bindValue="id">
                                    </ng-select>
                                    <app-dropdown (EmitRefreshClick)="getEmployeeDropDown()"></app-dropdown>
                                </div>
                            </div>
                            <!-- Client -->
                            <div class="col-lg-6">
                                <div class="col-lg-12">
                                    <label style="font-weight:bold">Client </label>
                                </div>
                                <div class="col-lg-12 d-flex">
                                    <ng-select [(ngModel)]="filters.filterClient" id="TVClient" [searchable]="true"
                                        [clearable]="true" class="w-100" [items]="AllClientDropDownListwithStatus"
                                        bindLabel="names" bindValue="id">
                                    </ng-select>
                                    <app-dropdown (EmitRefreshClick)="getClientDropDown()"></app-dropdown>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <!-- Service Group -->
                            <!-- <div class="col-lg-6">
                                <div class="col-lg-12">
                                    <label style="font-weight:bold">Service Group </label>
                                </div>
                                <div class="col-lg-12 d-flex">
                                    <ng-select class="w-100" id="TVServiceGroup" [(ngModel)]="serviceGroupFilter"
                                        [searchable]="true" [clearable]="true"
                                        [items]="ViewInputProperty.serviceGroupList" bindLabel="name" bindValue="id"
                                        (ngModelChange)="getServiceCode()">
                                    </ng-select>
                                    <app-dropdown
                                        (EmitRefreshClick)="refreshtoGetServiceGroupDropdownValues()"></app-dropdown>
                                </div>
                            </div> -->
                            <!-- Service Code -->
                            <div class="col-lg-6">
                                <div class="col-lg-12">
                                    <label style="font-weight:bold">Service Code</label>
                                </div>
                                <div class="col-lg-12 d-flex">
                                    <ng-select class="w-100" id="TVServiceCode" [(ngModel)]="ServiceCodeFilter"
                                        [searchable]="true" [clearable]="true" [items]="ViewInputProperty.ServiceCode"
                                        bindLabel="Value" bindValue="Key">
                                    </ng-select>

                                </div>
                            </div>
                        </div>
                        <div class="row mt-2 pl-3 ">
                            <!-- Add Manual Entry -->
                            <div class="col-lg-6 ">
                                <!-- <button class="btn blue-btn " (click)="AddManualEntry()">Add
                                    Manual Entry</button> -->
                                <!-- Print Timesheet -->
                                <button class="btn blue-btn  ml-2" data-bs-toggle="modal"
                                    data-bs-target="#printtimesheetmodel">
                                    Print Timesheet</button>
                                    <button class="btn blue-btn  ml-2" style="margin-left: 2px;" data-bs-toggle="modal" [disabled]="TimesheetDataList?.length == 0"
                                    data-bs-target="#exportascsvmodel">Export as CSV
                                    </button>
                            </div>
                            <div class="col-lg-6 text-right">
                                <!-- Apply -->
                                <button type="button" class="btn blue-btn " style="margin-right: 3px;" [disabled]="filters.filterEndDate==null || filters.filterEndDate==undefined ||
                            filters.filterEndDate==''||
                            filters.filterStartDate==null || filters.filterStartDate==undefined ||
                            filters.filterStartDate==''
                            " (click)="ApplyFilter()">Apply
                                </button>
                                <!-- Refresh -->
                                <button class="btn blue-btn" (click)="Refresh()"><i _ngcontent-lep-c69=""
                                        class="fa fa-repeat">&nbsp;</i>Refresh</button>
                            </div>
                        </div>
                        <div class="row mt-2 pl-3 pr-3">
                            <div class="col-lg-12 ">
                                <!-- Ejs-grid View -->
                                <div class="control-section">
                                     <!-- 
                                                                          When adding/removing columns to this grid:
                                                                          1. Update timesheetTotalColumns constant in timesheet-view.component.ts
                                                                          2. This prevents localStorage persistence conflicts
                                                                          3. Grid ID 'TimesheetGrid' maps to localStorage key 'gridTimesheetGrid'
                                                                          -->
                                    <ejs-grid #gridTimesheet id='TimesheetGrid' [dataSource]='GridDataList|async'
                                        [allowReordering]="true" 
                                       [enablePersistence]="true"  [allowResizing]='true' (resizeStop)="onResize($event)"
                                        (queryCellInfo)='validatebutton($event)' [childGrid]='childGrid'
                                        [allowSorting]='true' allowPaging='true' [allowFiltering]='true'
                                        (dataStateChange)='dataStateChange($event)' [pageSettings]='initialPage'
                                        [filterSettings]='filterOptions' (actionComplete)="onActionComplete($event)"
                                        [showColumnChooser]='true'>
                                        <e-columns>
                                            <!-- <e-column field="timesheet" uid="action" headerText="Actions"
                                                textAlign='center' [allowEditing]='false' Width=80
                                                [allowFiltering]="false">
                                                <ng-template #template let-data>
                                                    <button class="btn btn-edit-table Ationsubbtn ml-2" disabled
                                                        (click)="getTimesheetUpload(data.serialNo);editserialnumber=data.serialNo"
                                                        data-bs-target="#timesheetuploadview" data-bs-toggle="modal"><i
                                                            class="fa fa-eye fa-lg"></i></button>
                                                    <button class="btn btn-edit-table Ationsubbtn ml-2" disabled
                                                        data-bs-target="#EditClientEmployee" data-bs-toggle="modal"
                                                        (click)="edittimesheet(data,$event)"><i
                                                            class="fa fa-edit"></i></button>
                                                    <button class=" btn btn-delete-table ml-2" disabled
                                                        (click)="selectToDelete(data);showPayrollNotification(data.paidpayrolls)">
                                                        <i class="fa fa-trash fa-lg"></i></button>
                                                </ng-template>
                                            </e-column> -->
                                            <!-- Client -->
                                            <e-column width=120 field='clientName' headerText='Client'
                                                textAlign='left' [allowEditing]='false' type='string'>
                                                <ng-template #filterTemplate let-data>
                                                    <ejs-maskedtextbox
                                                        placeholder="Enter the value"></ejs-maskedtextbox>
                                                </ng-template>
                                            </e-column>
                                            <!-- Employee -->
                                            <e-column field='EmployeeName' headerText='Employee' textAlign='left'
                                                [allowEditing]='false' width=120 type='string'>
                                                <ng-template #filterTemplate let-data>
                                                    <ejs-maskedtextbox
                                                        placeholder="Enter the value"></ejs-maskedtextbox>
                                                </ng-template>
                                            </e-column>
                                            <!-- Service Code -->
                                            <e-column field='masterCode' headerText='Service Code' textAlign='left'
                                                [allowEditing]='false' width=100 type='string'>
                                                <ng-template #filterTemplate let-data>
                                                    <ejs-maskedtextbox
                                                        placeholder="Enter the value"></ejs-maskedtextbox>
                                                </ng-template>
                                            </e-column>
                                            <!-- From Date -->
                                            <e-column field='fromDate' headerText='From Date' textAlign='left'
                                                [allowEditing]='false' width=100 type='date' [format]='formatOptions'
                                                [allowFiltering]="false" [allowSorting]='false'>
                                            </e-column>
                                            <!-- To Date -->
                                            <e-column field='toDate' headerText='To Date' textAlign='left'
                                                [allowEditing]='false' width=100 type='date' [format]='formatOptions'
                                                [allowFiltering]="false" [allowSorting]='false'></e-column>
                                          
                                           
                                           
                                            <!-- Timesheet Status -->
                                            <e-column field='timesheetStatusLid' headerText='Timesheet Status'
                                                textAlign='left' [allowEditing]='false' width=100 type='string'
                                                [allowFiltering]="false">
                                                <!-- <ejs-dropdownlist id='dropdata2' placeholder='Select a Signature'
                                                    [dataSource]='dropdatas' [popupHeight]='height'></ejs-dropdownlist> -->
                                            </e-column>
                                            <!-- Total Hours -->
                                            <e-column field='totalhrs' headerText="Total Hours" textAlign='left'
                                                [customAttributes]='customParentTHAttributes' [allowFiltering]="false"
                                                [allowEditing]='false' width=100 type='string'
                                                [allowSorting]='false'>
                                                <ng-template #filterTemplate let-data>
                                                    <ejs-maskedtextbox
                                                        placeholder="Enter the value"></ejs-maskedtextbox>
                                                </ng-template>
                                            </e-column>
                                        
                                            <!-- Paid Payroll -->
                                            <!-- <e-column field='paidpayrolls' headerText='Paid Payroll'
                                                [allowSorting]='false' textAlign='left' width=80 type='string'>
                                                <ng-template #filterTemplate let-data>
                                                    <ejs-dropdownlist id='dropdata3' placeholder='Select a Paid Payroll'
                                                        [dataSource]='dropdatas'
                                                        [popupHeight]='height'></ejs-dropdownlist>
                                                </ng-template>
                                            </e-column> -->
                                            <e-column width="50" [showInColumnChooser]='false'>
                                                <ng-template #headerTemplate let-data>
                                                    <div class="d-none d-lg-block">
                                                        <span id='show' (click)='showColumn()'><i
                                                                class="fa fa-cog fa-lg" aria-hidden="true">
                                                            </i></span>
                                                    </div>
                                                </ng-template>
                                            </e-column>
                                        </e-columns>
                                        <e-aggregates>
                                            <e-aggregate>
                                                <e-columns>
                                                    <e-column type="Sum" field="totalhrs" format="C2">
                                                        <ng-template #footerTemplate let-data>Total Hours:
                                                            {{totalhrsSummaryMinstr}}
                                                        </ng-template>
                                                    </e-column>
                                                </e-columns>
                                            </e-aggregate>
                                        </e-aggregates>
                                    </ejs-grid>
                                     <!-- 
                                                                          When adding/removing columns to this grid:
                                                                          1. Update timesheetTotalColumns constant in timesheet-view.component.ts
                                                                          2. This prevents localStorage persistence conflicts
                                                                          3. Grid ID 'TimesheetGrid' maps to localStorage key 'gridTimesheetGrid'
                                                                          -->
                                    <div *ngIf="TimesheetDataList.length == 0" class="text-center" style="color:red">
                                        <p>No data available</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
    <ng-template #elsecondition>
        <div class="row mt-4 ">
            <div class="col ">
                <div widget class="card border-0 box-shadow">
                    <div class="card-body  widget-body pt-2">
                        <div class="text-center text-danger">
                            <label class="font-red animate-charcter"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select
                                agency to
                                view
                                details</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

<!-- Child Template -->
<ng-template #childtemplate let-data>
    <!-- <div><button class="btn btn-edit-table Ationsubbtn ml-2" disabled><i class="fa fa-edit"
                (click)="openedit($event)"></i></button>
        <button class="btn btn-delete-table ml-2" disabled id="enablechilddelete"
            (click)="DeleteChildGrid(data);showPayrollNotificationinchild(data?.paidpayroll);">
            <i class="fa fa-trash fa-lg"></i></button>
    </div> -->
</ng-template>
<!-- Edit Client & Employee  Parent-->
<span data-bs-target="#EditClientEmployee" data-bs-toggle="modal" id="editall"></span>
<div class="modal fade " id="EditClientEmployee" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog mw100" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Edit Timesheet</h5>
                <button type="button" class="close" data-bs-dismiss="modal" (click)="clientAuthorizationId=null">&times;</button>
            </div>
            <div class="modal-body ">
                <div class="row">
                    <!-- Client Name -->
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label style="font-weight:bold">Client Name </label>
                        </div>
                        <div class="col-lg-12">
                            <ng-select [clearable]="true" [searchable]="true" class="tdropdown" [(ngModel)]="editcli"
                                [items]="ViewInputProperty.ClientDropDown" bindLabel="names" bindValue="id" (ngModelChange)="getAuthorizationDetails()">
                            </ng-select>
                        </div>
                    </div>
                    <!-- Employee Name -->
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label style="font-weight:bold">Employee Name </label>
                        </div>
                        <div class="col-lg-12">
                            <ng-select [(ngModel)]="editemp" [searchable]="true" [clearable]="true" class="tdropdown"
                                [items]="ViewInputProperty.EmployeeDropDown" bindLabel="names" bindValue="id">
                            </ng-select>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label class="manualentry-label mr-0 ml-3">Service</label>
                        </div>
                        <div class="col-lg-12">
                            <ng-select  [(ngModel)]="editservice"  id="TVService" [searchable]="true"
                            [clearable]="true" [items]="AuthorizationDetails" class="tdropdown"
                            bindLabel="Value" bindValue="Key"
                           (ngModelChange)="getClientAuth()">
                        </ng-select>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-lg-12">
                        <button class="m-5" class="btn blue-btn ml-3" *ngIf="AuthorizationDetails.length==0"
                        (click)="AddClientAuthorization()">Add New
                        Authorization</button> 
                    </div>
                </div>
                <div class="row ml-0">
                    <div class="col-lg-12">
                        <div class="table-responsive">
                            <table class="table table-hover table-bordered mt-3  ">
                                <thead style="text-align: center;font-size: smaller;">
                                    <th class="pointer ttablehead"
                                        style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;position: relative">
                                        Action
                                    </th>
                                    <th class="pointer ttablehead"
                                        style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                        Start Date
                                    </th>
                                    <th class="pointer ttablehead"
                                        style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                        End Date
                                    </th>
                                    <th class="pointer ttablehead"
                                        style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                        Service
                                    </th>
                                    <th class="pointer ttablehead"
                                        style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                        Description
                                    </th>
                                    <th class="pointer ttablehead"
                                        style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                        Insurance Number#
                                    </th>
                                    <th class="pointer ttablehead"
                                        style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                        Total Units
                                    </th>
                                    <th class="pointer ttablehead"
                                        style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                        Payer Name
                                    </th>
                                    <th class="pointer ttablehead"
                                        style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                        Units Used
                                    </th>
                                    <th class="pointer ttablehead"
                                        style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                        Units Remaining
                                    </th>
                                    <th class="pointer ttablehead"
                                        style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                        Hours Remaining
                                    </th>
                                    <th class="pointer ttablehead"
                                        style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                        Hours/day
                                    </th>
                                    <th class="pointer ttablehead"
                                        style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                        Hours/week
                                    </th>
                                    <th class="pointer ttablehead"
                                        style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                        Remaining Hours/day Based On Last Visit Date
                                    </th>

                                </thead>
                                <tbody style="text-align: center;font-size: 12px;">
                                    <tr *ngFor="let specifyAuth of AuthorizationDetails;let index=index"
                                        [style.backgroundColor]="specifyAuth.isAuthBoolean==true?'lightgray':'white'">
                                        <td style="text-align: left;position: relative;">
                                            <button class="btn blue-btn btn-sm ml-1 mr-1" style="font-size:11px"
                                                (click)="selectSpecifyService(specifyAuth)">Select
                                            </button>
                                        </td>
                                        <td>
                                            {{specifyAuth.startDate| date:'MM/dd/yyyy'}}
                                        </td>
                                        <td>
                                            {{specifyAuth.endDate| date:'MM/dd/yyyy'}}
                                        </td>
                                        <td>
                                            {{specifyAuth.masterServiceCode}}
                                        </td>
                                        <td>
                                            {{specifyAuth.serviceDesc}}
                                        </td>
                                        <td>
                                            {{specifyAuth.insuranceNo}}
                                        </td>
                                        <td>
                                            {{specifyAuth.totalUnits}}
                                        </td>
                                        <td>
                                            {{specifyAuth.payorName}}
                                        </td>
                                        <td>
                                            {{specifyAuth.unitsUsed}}
                                        </td>
                                        <td>
                                            {{specifyAuth.unitsRemaining}}
                                        </td>
                                        <td [style.backgroundColor]="isColorEditValue[index]==true?'yellow':''">
                                            {{specifyAuth.remaingHours}}
                                        </td>
                                        <td>
                                            {{specifyAuth.hoursPerDay}}
                                        </td>
                                        <td>
                                            {{specifyAuth.hoursPerWeek}}
                                        </td>
                                        <td>
                                            {{specifyAuth.hoursPerDayBasedOnLastVisitDate}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div *ngIf="AuthorizationDetails.length == 0" class="text-center" style="color:red">
                            <p>No data available</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" [disabled]="editcli==null||editcli==undefined||
          editemp==undefined||editemp==null || AuthorizationDetails.length==0 ||
          clientAuthorizationId==0|| clientAuthorizationId==null" (click)="editTotaltimesheet();">Update & Close</button>
                <button type="button" class="btn blue-btn" data-bs-dismiss="modal" data-bs-target="#modal" (click)="clientAuthorizationId=null">Cancel</button>
            </div>
        </div>
    </div>
</div>
<!-- Delete All Timesheet -->
<span data-bs-target="#deleteAllTimesheet" data-bs-toggle="modal" id="deleteall"></span>
<div class="modal fade " id="deleteAllTimesheet" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog " role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Delete Timesheet</h5>
                <button type="button" class="close" data-bs-dismiss="modal">&times;</button>

            </div>
            <div class="alert alert-warning alert-dismissible fade show" *ngIf="saveErr!=''" role="alert">
                <p>{{saveErr}}</p>
                <button type="button" class="close" data-bs-dismiss="alert" aria-label="Close" (click)="saveErr=''">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="resetPass">
                    <div class="row">
                        <div class="col-lg-2">
                            <label class="manualentry-label">Password<sup style="color:red; font-size: 1.35em;
                          top: 0em;">&nbsp;*</sup></label>
                        </div>
                        <div class="col-lg-5">
                            <input type="password" class="form-control" formControlName="Password" id="DeletePassword"
                                [(ngModel)]="deleteList.admin_Password" (keyup)="passvalid($event)">
                            <div *ngIf="resetPass.controls['Password'].invalid && (resetPass.controls['Password'].dirty || resetPass.controls['Password'].touched) "
                                class="alert alert-danger" style="height: 30px; margin-top: 10px;">
                                <div *ngIf="resetPass.controls['Password'].errors.required">
                                    Password is required.
                                </div>
                            </div>
                            <div *ngIf="passerror && resetPass.controls['Password'].valid  " class="alert alert-danger">
                                <div>
                                    Enter Valid Password
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <label class="passwordnote mt-5 "><i>Note:&nbsp;Password should contain atleast 8
                                    characters/ digits includes 1 special character, 1 lower and uppercase characters
                                </i></label>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" [disabled]="!resetPass.valid ||passerror"
                    (click)="deletetotalTimesheet()" id="DeleteButton">Delete</button>
                <button type="button" class="btn blue-btn" data-bs-dismiss="modal" data-bs-target="#modal"
                    (click)="CancelDelete()" id="CancelDeleteButton">Cancel</button>
            </div>
        </div>
    </div>
</div>
<!-- Update Child Timesheet -->
<span data-bs-target="#updateTimesheet" data-bs-toggle="modal" id="update"></span>
<div class="modal fade " id="updateTimesheet" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog mw100" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Update Timesheet</h5>
                <button type="button" class="close" data-bs-dismiss="modal" (click)="clientAuthorizationId=null">&times;</button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-6">
                        <!-- Employee -->
                        <div class="col-lg-12">
                            <label class="manualentry-label mr-0 ml-3">Employee
                                Name</label>
                        </div>
                        <div class="col-lg-12">
                            <input type="text" class="form-control" [(ngModel)]="editEmployee" [disabled]="true">
                        </div>
                    </div>
                    <!-- Client -->
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label class="manualentry-label mr-0 ml-3">Client
                                Name</label>
                        </div>
                        <div class="col-lg-12">
                            <input type="text" class="form-control" id="TVClientName" [(ngModel)]="editClient"
                                [disabled]="true">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <!-- TimeSheet -->
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label class="manualentry-label mr-0 ml-3">TimeSheet
                                Date</label>
                        </div>
                        <div class="col-lg-12">
                            <my-date-picker [options]="myDatePickerOptions" id="TVTimesheetDate" [selDate]="editDate"
                                placeholder="mm/dd/yyyy"
                                (inputFieldChanged)="TimesheetViewDatePickers($event,'inputchanged','editdate')"
                                (dateChanged)="TimesheetViewDatePickers($event,'datachanged','editdate')">
                            </my-date-picker>
                        </div>
                    </div>
                    <!-- Service -->
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label class="manualentry-label mr-0 ml-3">Service</label>
                        </div>
                        <div class="col-lg-12">
                            <ng-select  [(ngModel)]="editservice"  id="TVService" [searchable]="true"
                            [clearable]="true" [items]="AuthorizationDetails" class="tdropdown"
                            bindLabel="Value" bindValue="Key"
                           (ngModelChange)="getClientAuth()">
                        </ng-select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <!-- Work Hour -->
                    <div class="col-lg-6">
                        <div class="col-lg-12">
                            <label class="manualentry-label mr-0 ml-3">Work
                                Hour</label>
                        </div>
                        <div class="col-lg-12">
                            <input type="text" class="form-control" [(ngModel)]="edittime" id="TVWorkHours"
                                (keypress)="numberonly($event,'update')">
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <!-- Notes -->
                        <div class="col-lg-12">
                            <label class="manualentry-label mr-0 ml-3">Notes</label>
                        </div>
                        <div class="col-lg-12">
                            <input type="text" id="TVNotes" class="form-control" [(ngModel)]="editNotes">
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-lg-12">
                        <button class="m-5" class="btn blue-btn ml-3" *ngIf="AuthorizationDetails.length==0"
                        (click)="AddClientAuthorization()">Add New
                        Authorization</button> 
                    </div>
                </div>
                <div class="row ml-0">
                    <div class="col-lg-12">
                        <div class="table-responsive">
                            <table class="table table-hover table-bordered mt-3  ">
                                <thead style="text-align: center;font-size: smaller;">
                                    <th class="pointer ttablehead"
                                        style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;position: relative">
                                        Action
                                    </th>
                                    <th class="pointer ttablehead"
                                        style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                        Start Date
                                    </th>
                                    <th class="pointer ttablehead"
                                        style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                        End Date
                                    </th>
                                    <th class="pointer ttablehead"
                                        style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                        Service
                                    </th>
                                    <th class="pointer ttablehead"
                                        style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                        Description
                                    </th>
                                    <th class="pointer ttablehead"
                                        style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                        Insurance Number#
                                    </th>
                                    <th class="pointer ttablehead"
                                        style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                        Total Units
                                    </th>
                                    <th class="pointer ttablehead"
                                        style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                        Payer Name
                                    </th>
                                    <th class="pointer ttablehead"
                                        style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                        Units Used
                                    </th>
                                    <th class="pointer ttablehead"
                                        style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                        Units Remaining
                                    </th>
                                    <th class="pointer ttablehead"
                                        style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                        Hours Remaining
                                    </th>
                                    <th class="pointer ttablehead"
                                        style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                        Hours/day
                                    </th>
                                    <th class="pointer ttablehead"
                                        style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                        Hours/week
                                    </th>
                                    <th class="pointer ttablehead"
                                        style="color: white;background-color: #0D47A1;font-size: 11px;padding: 5px;">
                                        Remaining Hours/day Based On Last Visit Date
                                    </th>

                                </thead>
                                <tbody style="text-align: center;font-size: 12px;">
                                    <tr *ngFor="let specifyAuth of AuthorizationDetails;let index=index"
                                        [style.backgroundColor]="specifyAuth.isAuthBoolean==true?'lightgray':'white'">
                                        <td style="text-align: left;position: relative;">
                                            <button class="btn blue-btn btn-sm ml-1 mr-1" style="font-size:11px"
                                                (click)="selectSpecifyService(specifyAuth)">Select
                                            </button>
                                        </td>
                                        <td>
                                            {{specifyAuth.startDate| date:'MM/dd/yyyy'}}
                                        </td>
                                        <td>
                                            {{specifyAuth.endDate| date:'MM/dd/yyyy'}}
                                        </td>
                                        <td>
                                            {{specifyAuth.masterServiceCode}}
                                        </td>
                                        <td>
                                            {{specifyAuth.serviceDesc}}
                                        </td>
                                        <td>
                                            {{specifyAuth.insuranceNo}}
                                        </td>
                                        <td>
                                            {{specifyAuth.totalUnits}}
                                        </td>
                                        <td>
                                            {{specifyAuth.payorName}}
                                        </td>
                                        <td>
                                            {{specifyAuth.unitsUsed}}
                                        </td>
                                        <td>
                                            {{specifyAuth.unitsRemaining}}
                                        </td>
                                        <td [style.backgroundColor]="isColorEditValue[index]==true?'yellow':''">
                                            {{specifyAuth.remaingHours}}
                                        </td>
                                        <td>
                                            {{specifyAuth.hoursPerDay}}
                                        </td>
                                        <td>
                                            {{specifyAuth.hoursPerWeek}}
                                        </td>
                                        <td>
                                            {{specifyAuth.hoursPerDayBasedOnLastVisitDate}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div *ngIf="AuthorizationDetails.length == 0" class="text-center" style="color:red">
                            <p>No data available</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <div class="row w-100">
                    <div class="col-lg-7">
                        <p class="notealert ml-0"> Note:Date,Service,Work Hours & note field only
                            editable</p>
                    </div>
                    <div class="col-lg-5 pr-0">
                        <button class="btn blue-btn" (click)="UpdateTimesheetView()" [disabled]="edittime==null || edittime==undefined || edittime==''||
                        editservice==null || editservice==undefined || editservice==''||
                        editDate==null || editDate==undefined || editDate=='' || AuthorizationDetails.length==0 ||
                        clientAuthorizationId==0|| clientAuthorizationId==null">
                            Update & Close
                        </button>
                        <button class="btn blue-btn ml-1" data-bs-dismiss="modal" data-bs-target="#modal" (click)="clientAuthorizationId=null">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Upload View -->
<span data-bs-target="#timesheetuploadview" data-bs-toggle="modal" id="uploadtimesheetview"></span>
<div class="modal fade " id="timesheetuploadview" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog " role="document">
        <div class="modal-content">
            <div class="modal-header">
                <div class="row w-100">
                    <div class="col-lg-9">
                        <h5 class="modal-title font-header">TimeSheet Upload</h5>
                    </div>
                    <div class="col-lg-3"> <button class="btn blue-btn w-75" type="button" data-bs-target="#timsheetupload"
                            data-bs-toggle="modal">Upload</button>
                        <button type="button" class="close w-25" data-bs-dismiss="modal">&times;</button>
                    </div>
                </div>
            </div>
            <div class="modal-body">
                <ejs-grid #gridTimesheetUpload [dataSource]='GridTimesheetUploadList' [allowSorting]='true'
                    [allowResizing]='true' allowPaging='true' (resizeStop)="onResize_timesheetupload($event)">
                    <e-columns>
                        <!-- Actions -->
                        <e-column width=100 headerText="Actions" uid="action" textAlign='center'
                            [allowEditing]='false'>
                            <ng-template #template let-data>
                                <button class="btn btn-edit-table" (click)="DownloadUploadedFile(data)"><i
                                        class="fa fa-download"></i></button>&nbsp;
                                <button class="btn btn-delete-table" data-bs-target="#DocumentDeleteModel"
                                    data-bs-toggle="modal" (click)="setDocumentId(data)">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </ng-template>
                        </e-column>
                        <!-- S.NO. -->
                        <e-column width=100 field="serialnumber" headerText="S.NO."></e-column>
                        <!-- Sequence Number -->
                        <e-column width=100 field="sequenceNumber" headerText="Sequence Number"></e-column>
                        <!-- Timesheet Upload -->
                        <e-column width=100 field="timesheetUploadName" headerText="Timesheet Upload"></e-column>

                    </e-columns>
                </ejs-grid>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" data-bs-dismiss="modal" data-bs-target="#modal">Cancel</button>
            </div>
        </div>
    </div>
</div>
<!-- Timesheet upload -->
<span data-bs-target="#timsheetupload" data-bs-toggle="modal" id="uploads"></span>
<div class="modal fade modalbackgrod " id="timsheetupload" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog " role="document">
        <div class="modal-content">
            <div class="modal-header">
                <div class="row w-100 ml-0">
                    <div class="col-lg-12 pr-0" style="display: flex;">
                        <h5 class="modal-title font-header w-75">TimeSheet Upload</h5>
                        <button type="button" class="close" (click)="closetimesheetUpload()">&times;</button>
                    </div>
                </div>
            </div>
            <div class="modal-body">
                <div class="row" style="padding-left: 3%;">
                    <div class="custom-file" style="max-width: 80%;">
                        <input type="file" class="custom-file-input" id="customFile" name="filename" #myInput
                            accept=".pdf" (change)="onFileChanged($event)" style="margin-top: 3px;" multiple>
                        <label class="custom-file-label" for="customFile">Choose file</label>

                    </div>&nbsp;&nbsp;
                    <button class="btn blue-btn" [disabled]="!selected" data-bs-toggle="modal" data-bs-target="#openpdf"><i
                            class="fa fa-eye"></i></button>
                </div>

                <ng-container *ngIf="selected">
                    <div *ngFor=" let val of filearray" style="color: #004290;">
                        {{val.TimesheetUploadName}}
                    </div>

                </ng-container>
                <p style="color: red">Note:upload only pdf file</p>
            </div>
            <div class="modal-footer">
                <button class="btn blue-btn" type="button" (click)="uploadTimesheet();filearray=[];selected=false"
                    [disabled]="!selected">Save</button>
                <button type="button" class="btn blue-btn" (click)="filearray=[];selected=false" data-bs-dismiss="modal"
                    data-bs-target="#modal">Cancel</button>
            </div>
        </div>
    </div>
</div>
<!-- Single Delete -->
<span data-bs-target="#deleteTimesheet" data-bs-toggle="modal" id="delete"></span>
<div class="modal fade " id="deleteTimesheet" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog " role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Delete Timesheet</h5>
                <button type="button" class="close" data-bs-dismiss="modal">&times;</button>

            </div>
            <div class="alert alert-warning alert-dismissible fade show" *ngIf="saveErr!=''" role="alert">
                <p>{{saveErr}}</p>
                <button type="button" class="close" data-bs-dismiss="alert" aria-label="Close" (click)="saveErr=''">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="resetPass">

                    <div class="row">
                        <div class="col-lg-2">
                            <label style="font-weight: 600;margin-top:6px;">Password<sup style="color:red; font-size: 1.35em;
                          top: 0em;">&nbsp;*</sup></label>
                        </div>
                        <div class="col-lg-5">
                            <input type="password" class="form-control" formControlName="Password"
                                [(ngModel)]="deleteList.admin_Password" (keyup)="passvalid($event)">
                            <div *ngIf="resetPass.controls['Password'].invalid && (resetPass.controls['Password'].dirty || resetPass.controls['Password'].touched) "
                                class="alert alert-danger" style="height: 30px; margin-top: 10px;">
                                <div *ngIf="resetPass.controls['Password'].errors.required">
                                    Password is required.
                                </div>
                            </div>
                            <div *ngIf="passerror && resetPass.controls['Password'].valid  " class="alert alert-danger">
                                <div>
                                    Enter Valid Password
                                </div>

                            </div>
                        </div>

                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <label class="passwordnote mt-5"><i>Note:&nbsp;Password should
                                    contain atleast 8
                                    characters/
                                    digits includes 1 special character, 1 lower and uppercase characters
                                </i></label>
                        </div>
                    </div>
                </form>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" [disabled]="!resetPass.valid ||passerror"
                    (click)="deleteTimesheet()">Delete</button>
                <button type="button" class="btn blue-btn" data-bs-dismiss="modal" data-bs-target="#modal"
                    (click)="CancelDelete()">Cancel</button>
            </div>
        </div>
    </div>
</div>
<span id="openModal34" data-bs-target="#view271" data-bs-toggle="modal"></span>
<div class="modal fade" id="view271" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog1 modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header modal-header1 border-0">
                <h5 class="modal-title text-left font-header">271 Record</h5>
                <button type="button" class="close" data-bs-dismiss="modal" (click)="viewFiles271=false">&times;</button>
            </div>
            <div class="modal-body modal-body1">
                <div class="row">
                    <div class="col-lg-12">
                        <div style="width:730px ;padding-left:15px">
                            <div>271 Report</div>
                            <!-- <div *ngIf="viewFiles271">
                                <ng-container *ngFor="let edi271 of edi271list">
                                    <div class="row">
                                        <div class="col-lg-3">FileName</div>
                                        <div class="col-lg-9">: {{edi271.fileName}}</div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-3">Imported Date</div>
                                        <div class="col-lg-9">: {{edi271.importedDate|date:'MM/dd/yyyy'}}</div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-3">Unique ISA Id</div>
                                        <div class="col-lg-9">: {{edi271.unique271ISA}}</div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-3">Interchange Date</div>
                                        <div class="col-lg-9">: {{edi271.interchangeDateTime|date:'MM/dd/yyyy'}}</div>
                                    </div>
                                    <div class="Sender">
                                        <h2>Sender</h2>
                                        <div *ngIf="edi271.sender_EntityIdentifier!=null && edi271.sender_EntityIdentifier!=''"
                                            class="row">
                                            <div class="col-lg-3">Entity</div>
                                            <div class="col-lg-9">: {{edi271.sender_EntityIdentifier}}</div>
                                        </div>
                                        <div *ngIf="edi271.sender_Name!=null && edi271.sender_Name!=''" class="row">
                                            <div class="col-lg-3">Name</div>
                                            <div class="col-lg-9">: {{edi271.sender_Name}}</div>
                                        </div>
                                        <div *ngIf="edi271.sender_Id!= null && edi271.sender_Id!=''" class="row">
                                            <div class="col-lg-3">ID</div>
                                            <div class="col-lg-9">: {{edi271.sender_Id}} <br>
                                                ({{edi271.sender_IdQualifier}})</div>
                                        </div>
                                        <h6
                                            *ngIf="edi271.sender_CommunicationNumberQualifier1!=null && edi271.sender_CommunicationNumberQualifier1!=''">
                                            Contact</h6>
                                        <div>{{edi271.sender_ContactName}}</div>
                                        <div class="row">
                                            <div *ngIf="edi271.sender_CommunicationNumber1!=null && edi271.sender_CommunicationNumber1!=''"
                                                class="col-lg-3">{{edi271.sender_CommunicationNumberQualifier1}}</div>
                                            <div class="col-lg-9">: {{edi271.sender_CommunicationNumber1}}</div>
                                        </div>
                                        <div *ngIf="edi271.sender_CommunicationNumber2!=null && edi271.sender_CommunicationNumber2!=''"
                                            class="row">
                                            <div class="col-lg-3">{{edi271.sender_CommunicationNumberQualifier2}}</div>
                                            <div class="col-lg-9">: {{edi271.sender_CommunicationNumber2}}</div>
                                        </div>
                                        <div *ngIf="edi271.sender_CommunicationNumber3!=null && edi271.sender_CommunicationNumber3!=''"
                                            class="row">
                                            <div class="col-lg-3">{{edi271.sender_CommunicationNumberQualifier3}}</div>
                                            <div class="col-lg-9">: {{edi271.sender_CommunicationNumber3}}</div>
                                        </div>
                                    </div>
                                    <div class="Receiver">
                                        <h2>Receiver</h2>
                                        <div *ngIf="edi271.receiver_EntityIdentifier!=null && edi271.receiver_EntityIdentifier!=''"
                                            class="row">
                                            <div class="col-lg-3">Entity</div>
                                            <div class="col-lg-9">: {{edi271.receiver_EntityIdentifier}}</div>
                                        </div>
                                        <div *ngIf="edi271.receiver_Name!=null && edi271.receiver_Name!=''" class="row">
                                            <div class="col-lg-3">Name</div>
                                            <div class="col-lg-9">: {{edi271.receiver_Name}}</div>
                                        </div>
                                        <div *ngIf="edi271.receiver_Id!=null && edi271.receiver_Id!=''" class="row">
                                            <div class="col-lg-3">ID</div>
                                            <div class="col-lg-9">: {{edi271.receiver_Id}} <br>
                                                ({{edi271.receiver_IdQualifier}})</div>
                                        </div>
                                        <div *ngIf="edi271.receiver_AddressLine1 != null || edi271.receiver_AddressLine1!='' || edi271.receiver_City!=null || edi271.receiver_City !=''"
                                            class="row">
                                            <div class="col-lg-3">Address</div>
                                            <div class="col-lg-9">: {{edi271.receiver_AddressLine1}} <br
                                                    *ngIf="edi271.receiver_AddressLine2 != null">

                                                {{edi271.receiver_AddressLine2}} <br> {{edi271.receiver_City}} <br>
                                                {{edi271.receiver_StateCode}}
                                                <br> {{edi271.receiver_ZipCode}}
                                            </div>
                                        </div>
                                    </div>
                                    <ng-container *ngFor="let client of edi271?.clients">
                                        <div class="Client">
                                            <h3>Subscriber</h3>
                                            <div class="ClientBasicDetails">
                                                <div *ngIf="client.clientName!=null && client.clientName!=''"
                                                    class="row">
                                                    <div class="col-lg-3">Name</div>
                                                    <div class="col-lg-9">: {{client.clientName}}</div>
                                                </div>
                                                <div *ngIf="client.clientID!=null && client.clientID!=''" class="row">
                                                    <div class="col-lg-3">ID</div>
                                                    <div class="col-lg-9">: {{client.clientID}} <br>
                                                        ({{client.clientIdQualifier}})</div>
                                                </div>
                                                <div *ngIf="edi271.receiver_AddressLine1 != null || edi271.receiver_AddressLine1!='' || edi271.receiver_City!=null || edi271.receiver_City !=''"
                                                    class="row">
                                                    <div class="col-lg-3">Address</div>
                                                    <div class="col-lg-9">: {{client.addressLine1}} <br
                                                            *ngIf="client.addressLine2 != null">
                                                        {{client.addressLine2}} <br> {{client.city}} <br>
                                                        {{client.state}} <br> {{client.zipCode}}
                                                    </div>
                                                </div>
                                                <div *ngIf="client.dOB!=null && client.dOB!=''" class="row">
                                                    <div class="col-lg-3">DOB</div>
                                                    <div class="col-lg-9">: {{client.dOB|date:'MM/dd/yyyy'}}</div>
                                                </div>
                                                <div *ngIf="client.gender!=null && client.gender!=''" class="row">
                                                    <div class="col-lg-3">Gender</div>
                                                    <div class="col-lg-9">: {{client.gender}}</div>
                                                </div>
                                            </div>
                                            <div class="AAADetails"
                                                *ngIf="client.aaaDetails!=null && client.aaaDetails!=''">
                                                <h5>Subscriber Validation</h5>
                                                <ng-container *ngFor="let aaa of client?.aaaDetails">
                                                    <div *ngIf="aaa.validRequest!=null && aaa.validRequest!=''"
                                                        class="row">
                                                        <div class="col-lg-3">Valid ReQuest</div>
                                                        <div class="col-lg-9">: {{aaa.validRequest}}</div>
                                                    </div>
                                                    <div *ngIf="aaa.agencyQualifier!=null && aaa.agencyQualifier!=''"
                                                        class="row">
                                                        <div class="col-lg-3">Agency Qualifier</div>
                                                        <div class="col-lg-9">: {{aaa.agencyQualifier}}</div>
                                                    </div>
                                                    <div *ngIf="aaa.rejectReason!=null && aaa.rejectReason!=''"
                                                        class="row">
                                                        <div class="col-lg-3">Reason For Rejection</div>
                                                        <div class="col-lg-9">: {{aaa.rejectReason}}</div>
                                                    </div>
                                                    <div *ngIf="aaa.followupAction!=null && aaa.followupAction!=''"
                                                        class="row">
                                                        <div class="col-lg-3">Follow-Up Action</div>
                                                        <div class="col-lg-9">: {{aaa.followupAction}}</div>
                                                    </div>
                                                </ng-container>
                                            </div>
                                            <div class="LoopDetails">
                                                <ng-container *ngFor="let loop of client?.loopDetails">
                                                    <div class="EBandMessage">
                                                        <h5>Eligibility and Benefit Info</h5>
                                                        <div *ngIf="loop.eligibilityorBenefitInformation!=null && loop.eligibilityorBenefitInformation!=''"
                                                            class="row">
                                                            <div class="col-lg-3">Eligibility or Beneefit Information
                                                            </div>
                                                            <div class="col-lg-9">:
                                                                {{loop.eligibilityorBenefitInformation}}</div>
                                                        </div>
                                                        <div *ngIf="loop.benefitCoverageLevel!=null && loop.benefitCoverageLevel!=''"
                                                            class="row">
                                                            <div class="col-lg-3">Coverage Level</div>
                                                            <div class="col-lg-9">: {{loop.benefitCoverageLevel}}</div>
                                                        </div>
                                                        <div *ngIf="loop.serviceType!=null && loop.serviceType!=''"
                                                            class="row">
                                                            <div class="col-lg-3">Service Covered</div>
                                                            <div class="col-lg-9">: {{loop.serviceType}}</div>
                                                        </div>
                                                        <div *ngIf="loop.insuranceType!=null && loop.insuranceType!=''"
                                                            class="row">
                                                            <div class="col-lg-3">Insurance Type</div>
                                                            <div class="col-lg-9">: {{loop.insuranceType}}</div>
                                                        </div>
                                                        <div *ngIf="loop.planCoverageDescription!=null && loop.planCoverageDescription!=''"
                                                            class="row">
                                                            <div class="col-lg-3">Plan Coverage Description</div>
                                                            <div class="col-lg-9">: {{loop.planCoverageDescription}}
                                                            </div>
                                                        </div>
                                                        <div *ngIf="loop.timePeriodQualifier!=null && loop.timePeriodQualifier!=''"
                                                            class="row">
                                                            <div class="col-lg-3">Time Period</div>
                                                            <div class="col-lg-9">: {{loop.timePeriodQualifier}}</div>
                                                        </div>
                                                        <div *ngIf="loop.benefitAmount!=null && loop.benefitAmount!=''"
                                                            class="row">
                                                            <div class="col-lg-3">Benefit Amount</div>
                                                            <div class="col-lg-9">: {{loop.benefitAmount}}</div>
                                                        </div>
                                                        <div *ngIf="loop.benefitPercent!=null && loop.benefitPercent!=''"
                                                            class="row">
                                                            <div class="col-lg-3">Benefit Percentage</div>
                                                            <div class="col-lg-9">: {{loop.benefitPercent}}</div>
                                                        </div>
                                                        <div *ngIf="loop.quantityQualifier!=null && loop.quantityQualifier!=''"
                                                            class="row">
                                                            <div class="col-lg-3">Quantity Qualifier</div>
                                                            <div class="col-lg-9">: {{loop.quantityQualifier}}</div>
                                                        </div>
                                                        <div *ngIf="loop.authorizationorCertificationIndicator!=null && loop.benefitQuantity!=''"
                                                            class="row">
                                                            <div class="col-lg-3">Benefit Quantity</div>
                                                            <div class="col-lg-9">: {{loop.benefitQuantity}}</div>
                                                        </div>
                                                        <div *ngIf="loop.authorizationorCertificationIndicator!=null && loop.authorizationorCertificationIndicator!=''"
                                                            class="row">
                                                            <div class="col-lg-3">Authorization Certification</div>
                                                            <div class="col-lg-9">:
                                                                {{loop.authorizationorCertificationIndicator}}</div>
                                                        </div>
                                                        <div *ngIf="loop.inPlanNetwork!=null && loop.inPlanNetwork!=''"
                                                            class="row">
                                                            <div class="col-lg-3">InPlan Network</div>
                                                            <div class="col-lg-9">: {{loop.inPlanNetwork}}</div>
                                                        </div>
                                                        <div *ngIf="loop.cmP_ProductorServiceIDQualifier!=null && loop.cmP_ProductorServiceIDQualifier!=''"
                                                            class="row">
                                                            <h6>Composite Medical Procedure</h6>
                                                            <div class="col-lg-3">Product or Service ID Qualifier</div>
                                                            <div class="col-lg-9">:
                                                                {{loop.cmP_ProductorServiceIDQualifier}}</div>
                                                        </div>
                                                        <div *ngIf="loop.cmP_ProductServiceID!=null && loop.cmP_ProductServiceID!=''"
                                                            class="row">
                                                            <div class="col-lg-3">Product Service ID</div>
                                                            <div class="col-lg-9">: {{loop.cmP_ProductServiceID}}</div>
                                                        </div>
                                                        <div *ngIf="loop.cmP_ProcedureCode!=null && loop.cmP_ProcedureCode!=''"
                                                            class="row">
                                                            <div class="col-lg-3">Procedure Code</div>
                                                            <div class="col-lg-9">: {{loop.cmP_ProcedureCode}}</div>
                                                        </div>
                                                        <div *ngIf="loop.cmP_ProcedureModifiers!=null && loop.cmP_ProcedureModifiers!=''"
                                                            class="row">
                                                            <div class="col-lg-3">Procedure Modifiers</div>
                                                            <div class="col-lg-9">: {{loop.cmP_ProcedureModifiers}}
                                                            </div>
                                                        </div>
                                                        <div *ngIf="loop.cmP_Description!=null && loop.cmP_Description!=''"
                                                            class="row">
                                                            <div class="col-lg-3">Description</div>
                                                            <div class="col-lg-9">: {{loop.cmP_Description}}</div>
                                                        </div>
                                                        <div *ngIf="loop.diagnosisCodePointers!=null && loop.diagnosisCodePointers!=''"
                                                            class="row">
                                                            <div class="col-lg-3">Diagnosis Code Pointer</div>
                                                            <div class="col-lg-9">: {{loop.diagnosisCodePointers}}</div>
                                                        </div>
                                                        <div *ngIf="loop.messages!=null && loop.messages!=''"
                                                            class="row">
                                                            <div class="col-lg-3">Messages</div>
                                                            <div class="col-lg-9">: {{loop.messages}}</div>
                                                        </div>
                                                    </div>
                                                    <div class="DTPDetails">
                                                        <ng-container *ngFor="let dtp of loop?.dtpDetails">
                                                            <div *ngIf="dtp.dateTimeQualifier!=null && dtp.dateTimeQualifier!=''"
                                                                class="row">
                                                                <div class="col-lg-3">{{dtp.dateTimeQualifier}}</div>
                                                                <div class="col-lg-9">:
                                                                    {{dtp.dateTimePeriod|date:'MM/dd/yyyy'}}</div>
                                                            </div>
                                                        </ng-container>
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </ng-container>

                                </ng-container>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal"
                    (click)="viewFiles271=false">Cancel</button>
            </div>
        </div>
    </div>
</div>
<!-- Print Timesheet -->
<span id="printtimesheet" data-bs-toggle="modal" data-bs-target="#printtimesheetmodel"></span>
<div class="modal fade" id="printtimesheetmodel" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Print Timesheet</h5>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-5 pl-3 pr-0">
                        <span>Start date<sup class="super-script">*</sup></span>
                    </div>
                    <div class="col-lg-6">
                        <my-date-picker [selDate]="filterStartDateTimesheet" id="TVPrintStartDate"
                            placeholder="mm/dd/yyyy" (inputFieldChanged)="newTimeSheetdate($event,
                    'inputchanged','filtertimesheetstart')" (dateChanged)="newTimeSheetdate($event,
                    'datachanged','filtertimesheetstart')">
                        </my-date-picker>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-5 pl-3 pr-0">
                        <span>End date<sup class="super-script">*</sup></span>
                    </div>
                    <div class="col-lg-6">
                        <my-date-picker [selDate]="filterEndDateTimesheet" id="TVPrintEndDate" placeholder="mm/dd/yyyy"
                            (inputFieldChanged)="newTimeSheetdate($event,
                    'inputchanged','filtertimesheetend')"
                            (dateChanged)="newTimeSheetdate($event,'datachanged','filtertimesheetend')"
                            [disabled]="true">
                        </my-date-picker>
                    </div>
                </div>
                <div class="row ">
                    <div class="col-lg-5 pl-3 pr-0">
                        <span>Employee <sup class="super-script">*</sup></span>
                    </div>
                    <div class="col-lg-6">
                        <ng-select [(ngModel)]="timesheetreportEmployee" [searchable]="true" [clearable]="true"
                            [items]="AllEmployeeDropDownList" bindLabel="names" id="TVPrintEmployee" bindValue="id">
                        </ng-select>
                    </div>
                </div>
                <div class="row mt-1">
                    <div class="col-lg-5 pl-3 pr-0">
                        <span>Client <sup class="super-script">*</sup></span>
                    </div>
                    <div class="col-lg-6">
                        <ng-select [(ngModel)]="timesheetreportClient" [searchable]="true" [clearable]="true"
                            [items]="AllClientDropDownList" bindLabel="names" bindValue="id" id="TVPrintClient">

                        </ng-select>
                    </div>
                </div>            

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" [disabled]="filterStartDateTimesheet==null||
        filterStartDateTimesheet==undefined||filterStartDateTimesheet==''||filterEndDateTimesheet==null||
        filterEndDateTimesheet==undefined||filterEndDateTimesheet==''||timesheetreportEmployee==null||
        timesheetreportEmployee==undefined||timesheetreportEmployee==''||timesheetreportClient==null||
        timesheetreportClient==undefined||timesheetreportClient==''" (click)="generateTimesheetReport()">Print</button>
                <button type="button" class="btn blue-btn btn-sm" (click)="clearPrintTImeSheetValues()">Close</button>
            </div>
        </div>
    </div>
</div>
<!-- Power Bi Report -->
<span id="OpenReportModal" data-bs-toggle="modal" data-bs-target="#ReportModal"></span>
<div class="modal fade" id="ReportModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">{{reportHeader}}</h5>
                <div class="text-right">
                    <button class="btn blue-btn btn-sm mr-2" (click)="checkReport=false" data-bs-dismiss="modal">
                        Close</button>
                </div>
            </div>
            <div class="modal-body" style="height:600px">
                <ng-container *ngIf="checkReport== true">
                    <div style="width: 100%;height:100%" #reportContainer class="report-border"></div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
<!-- Delete -->
<span id="openDelete" data-bs-toggle="modal" data-bs-target="#DocumentDeleteModel"></span>
<div class="modal fade" id="DocumentDeleteModel" data-bs-backdrop="static">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    <span>Delete </span>
                </h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                Are you sure you want to Delete?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="DeleteDocumentfile()">Yes</button>
                <button type="button" class="btn blue-btn btn-sm" (click)="closeDeleteModal()">No</button>
            </div>
        </div>
    </div>
</div>
<!-- Show Payroll Notification -->
<span data-bs-target="#showpayrollmessage" data-bs-toggle="modal" id="showPaidpayroll"></span>
<div class="modal fade " id="showpayrollmessage" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog " role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Delete Confirmation</h5>
            </div>
            <div class="modal-body">
                <div class="row ml-1">
                    <label class="text-danger">This timesheet has a paid payroll. Do you want to proceed ?</label>
                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" data-bs-target="#deleteAllTimesheet" data-bs-toggle="modal"
                    (click)="closePayrollNotification()" id="PaidPayrollOkButton">Ok</button>
                <button type="button" class="btn blue-btn" data-bs-dismiss="modal" data-bs-target="#modal"
                    id="PaidPayrollCancelButton">Cancel</button>
            </div>
        </div>
    </div>
</div>
<!-- Show Payroll Notification -->
<span data-bs-target="#showpayrollmessageinchild" data-bs-toggle="modal" id="showPaidpayrollchild"></span>
<div class="modal fade " id="showpayrollmessageinchild" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog " role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Delete Confirmation</h5>
            </div>
            <div class="modal-body">
                <div class="row ml-1">
                    <label class="text-danger">This timesheet has a paid payroll. Do you want to proceed ?</label>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn" data-bs-target="#deleteTimesheet" data-bs-toggle="modal"
                    (click)="closePayrollNotificationinchild()">Ok</button>
                <button type="button" class="btn blue-btn" data-bs-dismiss="modal" data-bs-target="#modal">Cancel</button>
            </div>
        </div>
    </div>
</div>
<!-- Pdf View -->
<span id="openpdfmodal" data-bs-toggle="modal" data-bs-target="#openpdf"></span>
<div class="modal fade " id="openpdf" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"
    data-bs-backdrop="static">
    <div class="modal-dialog pdfviewmodal" role="document">
        <div class="modal-content ">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">View file</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
                <pdf-viewer [src]="pdfSrc" [render-text]="true" style="display: block;height:500px"></pdf-viewer>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>

<div *ngIf="EditAuthorization">
    <app-client-authorization-edit *ngIf="EditAuthorization" (EventToEditAuth)="dataEmitfromChild($event)"
        [DataFromAuthorizationList]="authinput">
    </app-client-authorization-edit>
</div>


<!-- exportascsvmodel -->

<span id="exportascsv" data-bs-toggle="modal" data-bs-target="#exportascsvmodel"></span>
<div class="modal fade" id="exportascsvmodel" aria-hidden="true" data-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Export as CSV</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
               
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-6">
                        <button class="btn blue-btn btn-sm mb-1" (click)="exportTimesheetWithPaginationCsv()">
                            Print Current page
                        </button>
                    </div>
                    <div class="col-lg-6">
                        <button class="btn blue-btn btn-sm mb-1" (click)="exportAllTimesheetCsv()">
                            Print All page
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">
                    Close
                </button>
            </div>
        </div>
    </div>
</div>